import { useNativeAppStore } from './store';
import { NativeAppState } from './types';

export const actionsCreator = ({
  setState
}: {
  setState: (state: Partial<NativeAppState>) => void;
}) => ({
  SET_IS_NATIVE_APP: (isNativeApp: boolean) => {
    setState({
      isNativeApp
    });
  },
  SET_IS_NATIVE_APP_LOADED: () => {
    setState({
      isNativeAppConfigLoaded: true
    });
  },
  SET_NATIVE_APP_CONFIG: (
    nativeAppConfig: NativeAppState['nativeAppConfig']
  ) => {
    setState({
      nativeAppConfig
    });
  },
  SET_ANDROID_LINK: (androidLink: string) => {
    setState({
      androidLink
    });
  },
  SET_IOS_LINK: (iosLink: string) => {
    setState({
      iosLink
    });
  },
  SET_VISIBLE_MOBILE_BANNER: (visibleMobileBanner: boolean) => {
    setState({
      visibleMobileBanner
    });
  },
  SET_PWA_INSTRUCTIONS: (visiblePWAInstructions: boolean) => {
    setState({
      visiblePWAInstructions
    });
  }
});

export const nativeAppActions = actionsCreator(useNativeAppStore);
